export default __webpack_public_path__ + "static/media/mb-cta-chevron-white.d56fa80d.svg";